// Shared rule: an account is "live" only when it is connected, its workspace is
// it has at least one active, unexpired seat.
export type SeatLite = { client_id: string | null; status: string | null; current_period_end: string | null };

export function hasActiveSeat(seats: SeatLite[], now = Date.now()): boolean {
  return seats.some((s) => s.status === "active" && !!s.current_period_end && new Date(s.current_period_end).getTime() > now);
}

export type InactiveReason = "Seat expired" | "Disconnected";

export function inactiveReasonOf(
  a: { clientStatus?: string | null; workspaceStatus?: string | null; seats: SeatLite[] },
  now = Date.now(),
): InactiveReason | null {
  if (!hasActiveSeat(a.seats, now)) return "Seat expired";
  if (a.clientStatus === "disconnected") return "Disconnected";
  return null;
}

/** Fetches per-account liveness for the given client ids. */
export async function fetchLiveness(supabase: any, ids: string[]): Promise<Map<string, InactiveReason | null>> {
  const out = new Map<string, InactiveReason | null>();
  if (ids.length === 0) return out;
  const [{ data: clients }, { data: seats }] = await Promise.all([
    supabase.from("clients").select("id, status, workspaces(subscription_status)").in("id", ids),
    supabase.from("account_subscriptions").select("client_id, status, current_period_end").in("client_id", ids),
  ]);
  const byClient = new Map<string, SeatLite[]>();
  (seats || []).forEach((s: SeatLite) => s.client_id && byClient.set(s.client_id, [...(byClient.get(s.client_id) || []), s]));
  (clients || []).forEach((c: any) =>
    out.set(c.id, inactiveReasonOf({ clientStatus: c.status, workspaceStatus: c.workspaces?.subscription_status, seats: byClient.get(c.id) || [] })),
  );
  return out;
}
